@import '~style-sheet-helpers/core.less';
@import '../../../../../../constants/spacing.module.less';

.amount-summary {
  flex: 1;
  max-width: 184px;
}

.amount-summary-label {
  gap: @space-8;
  display: flex;
}

.amount-summary-row-container {
  display: flex;
  justify-content: space-between;
  padding: @space-0 @space-0 @space-4;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.amount-summary-row-divider {
  border-color: var(--default--border-color--13);
}

.amount-summary-row-label {
  color: var(--default--text-color--15);
}

.amount-summary-row-label-with-icon {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.amount-summary-row-icon {
  display: flex;
  align-items: center;

  color: var(--default--icon--fill-color--12);
  width: 12px;
  height: 12px;
}
